// strings.js

const strings = {
    STRIPE_DEV_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/test_dR66pr4gZdW1bKMeVL", // nat
    STRIPE_PROD_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/8wM8xp0t02t84AE28Y", // nat

    STRIPE_SUBSCRIPTION_MANAGEMENT_URL: "https://billing.stripe.com/p/login/28ocP200L31J9gs7ss",
    SUBSCRIPTION_STATUS_API_URL: "https://funquiz.app/modular2/subscription-status",
    
    GENERIC_PAGE_TITLE: "National Park Art Gen AI 🎨",
    HOME_PAGE_TITLE: "Home - National Park Art Gen AI 🎨",
    DASHBOARD_PAGE_TITLE: "Home - National Park Art Gen AI 🎨",
    WELCOME_MESSAGE_H1_TITLE: "Welcome to National Park Art Gen AI 🎨",
    FX_DESCRIPTION_MESSAGE: "This f(x) can be used to generate national park art, enter a prompt and then press the 'Submit Input' button below to get your result!",
    
    MAIN_API_NAME: "nat_park_art_gen_ai_1",
    MAIN_API_URL: "https://funquiz.app/modular2/nat-park-art-gen-ai-1",

    PROD_CLERK_PUB_KEY: "pk_live_Y2xlcmsueW9sbGVnLmNvbSQ",
    DEV_CLERK_PUB_KEY: "pk_test_aGFybWxlc3MtYmVlLTY5LmNsZXJrLmFjY291bnRzLmRldiQ",

    // ... add more strings as needed
};



export default strings;